import { render } from "./indigo.vue?vue&type=template&id=90c692c0&scoped=true"
import script from "./indigo.vue?vue&type=script&lang=js"
export * from "./indigo.vue?vue&type=script&lang=js"

import "./indigo.vue?vue&type=style&index=0&id=90c692c0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90c692c0"]])

export default __exports__